import { uniqueInArray } from 'utils/functional';
import ERRORS from './errors';

import { _getRequest } from './helpers';

import * as http from '../http';

const getCreationRequest = ({ stops }) => {
  return _getRequest(stops);
};

const getAddJourneyErrorHandler = async (err) => {
  if (typeof err === 'string') {
    return err;
  }

  const error = await http.getError(err);

  if (error?.detail) {
    return error.detail;
  }

  return ERRORS.UNKNOWN;
};

const getAddRoutingErrorHandler = async (err) => {
  if (typeof err === 'string') {
    return err;
  }

  const message = err.message;

  if (message !== undefined) return message;

  const error = await http.getError(err);

  if (error?.detail) {
    return error.detail;
  }

  return ERRORS.UNKNOWN;
};

const _getHoverIndexesForStop = (stops, stopToCheck) => {
  return stops.reduce((acc, stop, index) => {
    const shipmentIdsToCheck = stopToCheck?.shipment_ids || [];
    const shipmentsForStop = stop?.shipment_ids || [];
    const shipmentIsIncludedInStop = shipmentIdsToCheck.some((shipmentId) =>
      shipmentsForStop.includes(shipmentId)
    );

    if (shipmentIsIncludedInStop) {
      return [...acc, index];
    }
    return acc;
  }, []);
};

const getHoverMapBasedOnRoutePlan = (routePlanStops) =>
  (routePlanStops || []).reduce(
    (acc, stop, index) => ({
      ...acc,
      [index]: _getHoverIndexesForStop(routePlanStops, stop),
    }),
    {}
  );

const someStopHasDifferentDate = (stops = []) => {
  const stopDates = stops
    .map((stop) => {
      const [date] = (stop.time_from || '').split('T');
      return date;
    })
    .filter(uniqueInArray);

  return stopDates?.length > 1;
};

export { default as mergeStops } from './mergeStops';

const getShipperOrdersBasedOnCurrentStopsForIndex = ({ index, currentStops }) => {
  const currentStop = currentStops[index];

  if (!currentStop) {
    return [];
  }

  return currentStop.shipper_orders || [];
};

export {
  getCreationRequest,
  getAddJourneyErrorHandler,
  getAddRoutingErrorHandler,
  ERRORS,
  getHoverMapBasedOnRoutePlan,
  someStopHasDifferentDate,
  getShipperOrdersBasedOnCurrentStopsForIndex,
};
